import * as React from 'react';
import MuiList, { type ListProps as MuiListProps } from '@mui/material/List';

export type ListProps = MuiListProps;

/**
 * List wrapper - simple wrapper around MUI List
 */
const List = React.forwardRef<HTMLUListElement, ListProps>(({ ...props }, ref) => {
  return <MuiList ref={ref} {...props} />;
});

List.displayName = 'List';

export default List;
